// FuecTrasladoDialog.js
// "Ver FUEC" desde el menú del traslado en Centro de Control y Coordinación (requerimiento 2026-10-14, R10):
// carga el FUEC actual del traslado y lo muestra con ViewFuecDialog. Ver/imprimir y descargar dependen de
// los permisos VER_FUEC_* y DESCARGAR_FUEC_* del módulo que lo abre.
import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Spin, message } from "antd";
import ViewFuecDialog from "./ViewFuecDialog";
import { downloadFuecPdf, fetchFuecById } from "./api";

function FuecTrasladoDialog({ open, fuecId, onClose, canDownload }) {
  const [fuec, setFuec] = useState(null);
  const [cargando, setCargando] = useState(false);
  // onClose suele ser una función nueva en cada render: no debe volver a disparar la carga
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open || !fuecId) return undefined;
    let vigente = true;
    setCargando(true);
    fetchFuecById(fuecId)
      .then((data) => vigente && setFuec(data))
      .catch((error) => {
        if (!vigente) return;
        message.error(error.response?.data?.error || "No se pudo cargar el FUEC del traslado");
        onCloseRef.current();
      })
      .finally(() => vigente && setCargando(false));
    return () => {
      vigente = false;
    };
  }, [open, fuecId]);

  const cerrar = useCallback(() => {
    setFuec(null);
    onClose();
  }, [onClose]);

  const descargar = useCallback(
    async (registro) => {
      if (!canDownload) return;
      try {
        message.loading({ content: "Generando PDF...", key: "pdf-fuec-traslado" });
        const blob = await downloadFuecPdf(registro.id);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `FUEC_${registro.numero_fuec}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        message.success({ content: "PDF descargado", key: "pdf-fuec-traslado" });
      } catch (error) {
        message.error({ content: "Error al descargar el PDF del FUEC", key: "pdf-fuec-traslado" });
      }
    },
    [canDownload]
  );

  if (!open) return null;

  if (cargando || !fuec) {
    return (
      <Modal open footer={null} onCancel={cerrar} title="FUEC del traslado" width={360} centered>
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin tip="Cargando FUEC..." />
        </div>
      </Modal>
    );
  }

  return (
    <ViewFuecDialog
      visible={open}
      fuec={fuec}
      onClose={cerrar}
      onDownload={descargar}
      canExport={canDownload}
      canPrint
      canDownload={canDownload}
    />
  );
}

FuecTrasladoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  fuecId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClose: PropTypes.func.isRequired,
  canDownload: PropTypes.bool,
};

FuecTrasladoDialog.defaultProps = {
  fuecId: null,
  canDownload: false,
};

export default FuecTrasladoDialog;
